import { useCallback, useState } from 'react';

type MsAuthProgressHandlers = {
  msAuthInProgress: boolean;
  msAuthFlowHandlers: {
    onFlowStart: VoidFunction;
    onFlowEnd: VoidFunction;
  };
};

type handler = null | VoidFunction;

/**
 * Helper for tracking ms auth in progress state.
 *
 * msAuthInProgress: boolean indicating if it the flow is still in progress.
 *
 * msAuthFlowHandlers should be passed as spread props into the
 * MicrosoftAuthentication component.
 *
 * Note, if you redirect after onAuthSuccess - then
 * onFlowEnd state setters will be a noop memory leak.
 */
const useMicrosoftAuthInProgress = (
  onStart: handler,
  onEnd?: handler,
): MsAuthProgressHandlers => {
  const [msAuthInProgress, setInProgress] = useState(false);
  const onFlowStart = useCallback(() => {
    setInProgress(true);
    if (typeof onStart === 'function') {
      onStart();
    }
  }, [onStart, setInProgress]);

  const onFlowEnd = useCallback(() => {
    setInProgress(false);
    if (typeof onEnd === 'function') {
      onEnd();
    }
  }, [onEnd, setInProgress]);

  return {
    msAuthInProgress,
    msAuthFlowHandlers: {
      onFlowStart,
      onFlowEnd,
    },
  };
};

export default useMicrosoftAuthInProgress;
